<template>
  <el-form
    ref="levelRightsFilterRef"
    class="search-form"
    :inline="true"
    :model="form"
    label-width="128px"
    @keyup.native.enter="handleSearch"
  >
    <el-row :class="openMore ? 'search-bar-content-show' : 'search-bar-content-close'">
      <el-col :span="6">
        <el-form-item label="姓名">
          <el-input
            v-model="form.unifyNameInStr"
            placeholder="请输入姓名"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="手机">
          <el-input
            v-model="form.mobileInStr"
            placeholder="请输入手机"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="分子公司">
          <el-select
            v-model="form.companyIds"
            filterable
            remote
            collapse-tags
            clearable
            :loading="loading"
            reserve-keyword
            multiple
            placeholder="请输入"
            :remote-method="remoteMethod"
            @clear="handleSearch"
          >
            <el-option
              v-for="item in options"
              :key="item.companyId"
              :label="item.companyName"
              :value="item.companyId"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="管控类型">
          <el-select
            v-model="form.controlTypes"
            clearable
            multiple
            placeholder="请选择"
            @clear="handleSearch"
          >
            <el-option
              v-for="item in CONTROL_TYPE_LIST"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="管控状态">
          <el-select
            v-model="form.controlStatuses"
            clearable
            multiple
            placeholder="请选择"
            @clear="handleSearch"
          >
            <el-option
              v-for="item in CONTROL_STATUS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="设备类型">
          <el-select
            v-model="form.equipmentTypes"
            clearable
            multiple
            placeholder="请选择"
            @clear="handleSearch"
          >
            <el-option
              v-for="item in DEVICE_LIST"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <div class="search-btns">
          <div class="moreData" @click="openMore = !openMore">
            {{ !openMore ? "展开筛选" : "收起筛选" }}
            <el-icon :class="openMore ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" />
          </div>
          <div class="form-btns">
            <el-button class="form-btn" @click.native.prevent="handleReset">
              重 置
            </el-button>
            <el-button
              class="form-btn"
              type="primary"
              @click.native.prevent="handleSearch"
            >
              查 询
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { controlCompanyPage } from '@/api/userControl';
import { CONTROL_TYPE_LIST, CONTROL_STATUS, DEVICE_LIST } from '../constant';

export default {
  name: 'ListFilter',
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      CONTROL_TYPE_LIST,
      CONTROL_STATUS,
      DEVICE_LIST,
      labelWidth: '128px',
      openMore: false,
      loading: false,
      options: [],
      controlStatusOptions: [],
    };
  },
  methods: {
    handleSearch() {
      this.$emit('search');
    },
    handleReset() {
      this.$emit('reset');
    },
    async remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        const result = await controlCompanyPage({ companyNameLike: query });
        this.loading = false;
        this.options = result.records;
      } else {
        this.options = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-btns {
  float:right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .moreData {
    font-size: 12px;
    color: #606266;
    margin-right: 28px;
    &:hover {
      cursor: pointer;
    }
    [class*=" el-icon-"],
    [class^="el-icon-"] {
      color: #06b880 !important;
      font-family: "element-icons" !important;
    }
  }
}
.search-form ::v-deep {
  .el-col {
    margin: 5px 0;
    .el-form-item {
      width: 100%;
      margin: 0;
      .el-form-item__label {
        white-space: nowrap;
        overflow: hidden;
      }
      .el-form-item__content {
        width: calc(100% - 128px);
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
.search-bar-content-close::v-deep {
  .el-col {
    display: none !important;
  }
  .el-col:nth-child(1) {
    display: block !important;
  }
  .el-col:nth-child(2) {
    display: block !important;
  }
  .el-col:nth-child(3) {
    display: block !important;
  }
  .el-col:nth-last-child(1) {
    float: right !important;
    display: block !important;
  }
}
.search-bar-content-show::v-deep {
  .el-col:nth-last-child(1) {
    float: right !important;
  }
}
</style>
